import React from "react";
import styles from "./style.module.scss";
import ImageSequence from "Utils/Assets/Images/ImageSequence.png";
import ImageSequence1 from "Utils/Assets/Images/ImageSequence1.png";
import ImageSequence2 from "Utils/Assets/Images/ImageSequence2.png";
import MeetUsWrapper from "Components/MeetUsWrapper";

const MVRCoinsJourney = () => {
    return (
        <div className={styles.root}>
            <MeetUsWrapper>
                <div className={styles.content}>
                    <div className={styles.titleContainer}>
                        <h1 className={styles.title}>
                            Your Path to Earning MVR Coins
                        </h1>
                    </div>
                    <div className={styles.cards}>
                        <div
                            className={styles.card}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.imageWrapper}>
                                <img
                                    src={ImageSequence}
                                    alt="MVR Coin"
                                    className={styles.coinImage}
                                />
                            </div>

                            <div className={styles.cardTag}>
                                Savings Staking
                            </div>

                            <h2 className={styles.cardTitle}>
                                MVR Wealth Coin
                            </h2>

                            <p className={styles.cardDescription}>
                                Investors stake MVR for APY rewards.
                            </p>

                            <button className={styles.cardButton}>
                                Read More Detail
                            </button>
                        </div>
                        <div
                            className={styles.card}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.imageWrapper}>
                                <img
                                    src={ImageSequence1}
                                    alt="MVR Coin"
                                    className={styles.coinImage}
                                />
                            </div>

                            <div className={styles.cardTag}>
                                Platform Staking
                            </div>

                            <h2 className={styles.cardTitle}>
                                MVR Influence Coin
                            </h2>

                            <p className={styles.cardDescription}>
                                Earned through daily engagement & tasks.
                            </p>

                            <button className={styles.cardButton}>
                                Read More Detail
                            </button>
                        </div>
                        <div
                            className={styles.card}
                            data-aos="fade-right"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.imageWrapper}>
                                <img
                                    src={ImageSequence2}
                                    alt="MVR Coin"
                                    className={styles.coinImage}
                                />
                            </div>

                            <div className={styles.cardTag}>
                                Transactions & RWA Utility
                            </div>

                            <h2 className={styles.cardTitle}>
                                MVR Core Coin
                            </h2>

                            <p className={styles.cardDescription}>
                                Primary currency for payments, rewards,  Etc.
                            </p>

                            <button className={styles.cardButton}>
                                Read More Detail
                            </button>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default MVRCoinsJourney;
